import pino from 'pino';
import store from 'store';
import axiosInstance from './axios';

import { isProduction } from 'config';
import { isLoggedIn } from 'store/slices/userSlice';

const loggerInstance = pino({
  name: 'cynet360',
  level: isProduction ? 'silent' : 'debug',
  browser: {
    asObject: true,
    transmit: {
      level: 'error',
      send: (_, logEvent) => {
        isLoggedIn(store.getState()) && axiosInstance.post('/webapp/ClientLogger/PostClientLogs', logEvent);
      }
    }
  }
});

export const logger = loggerInstance.child({ name: 'cynet360' });
